// src/utils/scheduleBatchTasks.js
// Basic, sensible ceramic workflow with default durations (in days).
// Tune as you like or pass custom durations per stage.

const DEFAULT_DURATIONS = {
  forming: 1,
  drying: 2,
  bisque: 1,
  glazing: 1,
  glazeFiring: 1,
  qcPack: 1,
  dispatch: 1,
};

const STAGES = [
  { key: "forming",      label: "Forming" },
  { key: "drying",       label: "Drying" },
  { key: "bisque",       label: "Bisque" },
  { key: "glazing",      label: "Glazing" },
  { key: "glazeFiring",  label: "Glaze Firing" },
  { key: "qcPack",       label: "QC & Pack" },
  { key: "dispatch",     label: "Dispatch" },
];

function atTime(ymd, hours = 9, minutes = 0) {
  const d = new Date(ymd);
  return new Date(d.getFullYear(), d.getMonth(), d.getDate(), hours, minutes, 0, 0);
}
function addDays(date, n) {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
}
function iso(x) { return new Date(x).toISOString(); }
function uid(prefix = "ev") { return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2,8)}`; }

export function buildBatchEvents({
  batchName,
  product,
  qty = 1,
  startDate,           // YYYY-MM-DD
  assigneeId,          // optional
  category = "Production",
  color = "#f97316",
  durations = DEFAULT_DURATIONS,
}) {
  const safeBatch = String(batchName || (product?.name || "Batch"));
  const batchId = `batch_${Date.now()}_${Math.random().toString(36).slice(2,6)}`;
  const firstStart = atTime(startDate || new Date().toISOString().slice(0, 10), 9, 0);

  let cursor = firstStart;
  const events = [];

  STAGES.forEach((stage) => {
    const days = Math.max(1, Number(durations[stage.key] ?? DEFAULT_DURATIONS[stage.key] ?? 1));
    const start = cursor;
    const end = addDays(atTime(start, 17, 0), days - 1); // inclusive day span

    events.push({
      id: uid("task"),
      title: `${safeBatch} — ${stage.label}`,
      start: iso(start),
      end: iso(end),
      qty,
      batch: safeBatch,
      category,
      color,
      // Views compatibility:
      tags: [stage.key],            // Kanban uses tags to find stage
      stage: stage.label,           // List view also reads stage text
      assigneeId: assigneeId || undefined,
      // Optional useful fields:
      productId: product?.id,
      productSku: product?.sku,
      productTitle: product?.title || product?.name,
      progress: 0,
      status: "todo",
    });

    // next stage begins the day after current ends
    cursor = addDays(start, days);
  });

  return { batchId, events };
}
